import React, { useEffect, useRef } from "react";
import ImageComponent from "@src/stories/elements/Image/Image";
import CarouselNavigation from "@src/stories/client/NavigationElements/CarouselNavigation";
import PhotoSwipeLightbox from "photoswipe/lightbox";
import 'photoswipe/style.css';

const Carousel = ({
  images,
  onImageClick,
  galleryType,
  videoUrl,
  isGiftCard,
}) => {
  const carouselRef = useRef(null);

  useEffect(() => {
    const lightbox = new PhotoSwipeLightbox({
      gallery: ".product-gallery__carousel",
      children: "a",
      pswpModule: () => import("photoswipe"),
    });

    lightbox.init();

    return () => {
      lightbox.destroy();
    };
  }, []);

  return (
    <div className={`product-gallery__carousel`}>
      <div
        x-data="carousel"
        className={`image-carousel`}
        x-init={`$nextTick(() => { initialise(true, false, false, false, false, 'gallery', false, ${false}) })`}
      >
        <div
          className={`carousel-images carousel w-full h-auto ${isGiftCard ? "gift-card" : ""}`}
          x-ref={images.length > 1 ? "carousel" : ""}
          ref={carouselRef}
        >
          {images.map((image, index) => (
            <a
              key={index}
              href={image.url}
              data-pswp-src={image.url}
              data-pswp-width={image.width || 2000}
              data-pswp-height={image.height || 3000}
              data-cropped="true"
              className="w-full"
            >
              <ImageComponent
                key={index}
                imageUrl={image.url}
                alt={image.alt || 'Product image'}
                isLazy={index > 0} // Don't lazy load the first image
                priority={index === 0} // Prioritize first image for LCP
                classes="w-full h-full object-cover"
                sizes="(max-width: 768px) 100vw, 60vw"
                aspectRatio="4/5"
              />
            </a>
          ))}
          {videoUrl && (
            <div
              key={"video"}
              className="video-item"
              style={{ height: "100%", width: "100%", pointerEvents: "none" }}
            >
              <div className="h-full video-iframe" data-v-2da62827="">
                <iframe
                  src={videoUrl}
                  width="100%"
                  height="100%"
                  data-v-2da62827=""
                ></iframe>
              </div>
            </div>
          )}
        </div>
      </div>
      <div className={"banner-carousel__controls z-[5]"}>
        <CarouselNavigation
          shiftPageDots={true}
          carouselRef={carouselRef}
          spread={true}
        />
      </div>
    </div>
  );
};

export default Carousel;
